<template>
  <div>
    <Head :title="__('Log In')" />

    <form
      class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto"
      @submit.prevent="attempt"
    >
      <div class="mb-6">
        <label
          class="block mb-2"
          for="email"
        >{{ __('Email Address') }}</label>
        <input
          id="email"
          v-model="form.email"
          class="form-control form-input form-control-bordered w-full"
          :class="{ 'form-control-bordered-error': form.errors.has('email') }"
          type="email"
          name="email"
          autofocus=""
          required
        >

        <HelpText
          v-if="form.errors.has('email')"
          class="mt-2 text-red-500"
        >
          {{ form.errors.first('email') }}
        </HelpText>
      </div>

      <div class="mb-6">
        <label
          class="block mb-2"
          for="password"
        >{{ __('Password') }}</label>
        <input
          id="password"
          v-model="form.password"
          class="form-control form-input form-control-bordered w-full"
          :class="{
            'form-control-bordered-error': form.errors.has('password'),
          }"
          type="password"
          name="password"
          required
        >

        <HelpText
          v-if="form.errors.has('password')"
          class="mt-2 text-red-500"
        >
          {{ form.errors.first('password') }}
        </HelpText>
      </div>

      <div class="flex mb-6">
        <Checkbox
          :model-value="form.remember"
          dusk="remember-button"
          :label="__('Remember me')"
          @change="() => (form.remember = !form.remember)"
        />

        <div
          v-if="supportsPasswordReset || forgotPasswordPath !== false"
          class="ml-auto"
        >
          <Link
            v-if="forgotPasswordPath === false"
            :href="$url('/password/reset')"
            class="text-gray-500 font-bold no-underline"
          >
            {{ __('Forgot your password?') }}
          </Link>
          <a
            v-else
            :href="forgotPasswordPath"
            class="text-gray-500 font-bold no-underline"
          >
            __('Forgot your password?')
          </a>
        </div>
      </div>

      <Button
        class="w-full flex justify-center mb-6"
        type="submit"
        :loading="form.processing"
      >
        <span>
          {{ __('Log In') }}
        </span>
      </Button>

      <DividerLine />

      <div class="flex justify-center">
        <Link
          :href="$url('/register')"
          class="text-gray-500 font-bold no-underline pl-2"
        >
          {{ __('Register') }}
        </Link>
      </div>
    </form>
  </div>
</template>

<script>
import Auth from '@/layouts/Auth'
import { Button, Checkbox } from 'laravel-nova-ui'

export default {
  name: 'LoginPage',

  components: {
    Checkbox,
    Button,
  },

  layout: Auth,


  data: () => ({
    form: Nova.form({
      email: '',
      password: '',
      remember: false,
    }),
  }),

  computed: {
    supportsPasswordReset() {
      return Nova.config('withPasswordReset')
    },
    forgotPasswordPath() {
      return Nova.config('forgotPasswordPath')
    },
    appName() {
      return Nova.config('appName');
    }
  },

  methods: {
    async attempt() {
      try {
        const { redirect } = await this.form.post(Nova.url('/login'))

        let path = { url: Nova.url('/'), remote: true }

        if (redirect !== undefined && redirect !== null) {
          path = { url: redirect, remote: true }
        }

        Nova.visit(path)
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },
  },
}
</script>
